import { getBrands } from 'common/api/v1/products';

import {
    FETCH_BRANDS,
    FETCH_BRANDS_FAILURE,
    FETCH_BRANDS_SUCCESS,
} from '../actionTypes';
import { addPanelsModalActions } from '../reducer';

export default () => (dispatch) => {
    dispatch(addPanelsModalActions[FETCH_BRANDS]());

    getBrands()
        .then((response) => {
            dispatch(
                addPanelsModalActions[FETCH_BRANDS_SUCCESS](response.data.data),
            );
        })
        .catch((error) =>
            dispatch(
                addPanelsModalActions[FETCH_BRANDS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
